module.exports = __webpack_public_path__ + "media/arcade-sounds.cdf946bf.mp3";